<template>
  <div>
    <div class="training-box1">
      <p class="training-title">
        <span>训练营</span
        ><span class="teainingMore"
          ><label @click="studyPath">更多</label>
          <label class="more_right"><van-icon name="arrow" /></label>
        </span>
      </p>
      <div class="training-content">
        <ul>
          <li
            v-for="item in trainingList"
            :key="item.id"
            @click="trainingMsg(item.id)"
          >
            <a>
              <img :src="item.iconUrl" alt="" />
            </a>
            <div class="right">
              <h4 class="training-list-title">
                {{ item.name }}
              </h4>
              <p class="training-list-time">
                {{ item.trainStartTime | formateData }}~{{
                  item.trainEndTime | formateData
                }}
              </p>
              <p class="training-list-progress" v-if="item.contentCount">
                <label
                  >学习时长{{ item.learnTotalTime | formateTime }}小时 已学{{
                    item.studyProcess
                  }}%</label
                >
                <van-progress
                  color="#1BB938"
                  :percentage="item.studyProcess"
                  :show-pivot="false"
                />
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "learningList",
  data: () => {
    return {
      trainingList: [],
      total: 0,
      params: {
        pageNum: 1,
        pageSize: 2,
        trainStatus: "",
      },
    };
  },
  computed: {},
  filters: {
    formateTime: function (val) {
      return val ? (val / 3600).toFixed(2) : val;
    },
    formateData: function (val) {
      return val.split(" ")[0];
    },
  },
  mounted () {
    this.trainList();
  },
  methods: {
    back () {
      this.$router.back();
    },
    trainingMsg (id) {
      this.$router.push({
        path: "/learning/Details",
        query: {
          id: id,
        },
      });
    },
    studyPath () {
      this.$router.push({
        path: "/learning",
        query: {
          backType: '2'
        }
        
      });
    },
    trainList () {
      let params = this.params;
      this.$api.training.trainList({ params }).then(({ data }) => {
        this.trainingList = data.list;
      });
    },
  },
};
</script>

<style lang="less" scoped>
* {
  padding: 0;
  margin: 0;
}
.training-box1 {
  margin: 0px 30px;
  position: relative;
  padding-top: 59px;
  padding-bottom: 60px;
  .training-title {
    height: 44px;
    span {
      font-size: 40px;
      font-weight: 500;
      color: #000000;
      line-height: 40px;
    }
    .teainingMore {
      height: 44px;
      font-size: 26px;
      color: #666666;
      text-align: center;
      line-height: 44px;
      position: absolute;
      right: 30px;
      .more_right {
        position: relative;
        i {
          position: absolute;
          top: 0px;
          margin-top: 2px;
        }
      }
    }
  }
  .training-content {
    margin-top: 50px;
    ul {
      position: relative;
      li {
        height: 150px;
        margin-bottom: 80px;
        a {
          width: 200px;
          height: 150px;
          border-radius: 16px;
          display: inline-block;
          overflow: hidden;
          img {
            width: 200px;
            height: 150px;
          }
        }
        .right {
          width: 466px;
          // height: 100%;
          margin-left: 20px;
          display: inline-block;
          position: absolute;
          .training-list-title {
            height: 34px;
            font-size: 34px;
            font-weight: 400;
            color: #000000;
            line-height: 1rem;
            max-width: 466px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .training-list-time {
            font-size: 24px;
            font-weight: 400;
            color: #999999;
            line-height: 24px;
            margin-top: 16px;
            margin-bottom: 20px;
          }
          .training-list-progress {
            label {
              font-size: 26px;
              font-weight: 400;
              color: #333333;
              margin-bottom: 12px;
              display: inline-block;
            }
          }
        }
      }
    }
  }
  .training-footer-box {
    position: relative;
    height: 100px;
    .training-footer {
      width: 100%;
      text-align: center;
      font-size: 24px;
      font-weight: 400;
      color: #b1b1b1;
      line-height: 33px;
      position: absolute;
      left: 50%;
      right: 50%;
      // bottom: 36px;
      transform: translate(-50%, -50%);
      padding-bottom: 120px;
      margin-top: 64px;
      span {
        margin: 0px 16px;
      }
    }
  }
  .training-footer-fixde {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 50%;
    right: 50%;
    transform: translate(-50%, -50%);
    .training-footer {
      width: 100%;
      text-align: center;
      font-size: 24px;
      font-weight: 400;
      color: #b1b1b1;
      line-height: 33px;
      padding-bottom: 75px;
      margin-top: 6px;
      -webkit-text-size-adjust:none;
      span {
        margin: 0px 16px;
        -webkit-text-size-adjust:none;
      }
    }
  }
}
</style>
